export default "__VITE_ASSET__Bxtar1dU__"